import React from 'react'
import style from './footer.module.css'
// Importation des icônes de réseaux sociaux (assure-toi d'avoir react-icons ou FontAwesome)
import { FaFacebook, FaLinkedin, FaTwitter, FaInstagram } from 'react-icons/fa'
import { ImLocation } from 'react-icons/im'


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={style.homeFooter}>
      <div className={style.footerContainer}>

        {/* Colonne 1 : Branding */}
        <div className={style.footerColumn}>
          <h2 className={style.footerLogo}>Get-Conseil</h2>
          <p className={style.footerDesc}>
            GET Conseil, ASSUREZ L’AVENIR
          </p>
          <div className={style.socialIcons}>
            <FaFacebook /> <FaLinkedin /> <FaTwitter /> <FaInstagram />
          </div>
        </div>

        {/* Colonne 2 : Services */}
        <div className={style.footerColumn}>
          <h3>Services</h3>
          <ul>
            <li>Conseil en Gestion</li>
            <li>Administration de Gestion</li>
            <li>Accompagnement Juridique</li>
            <li>Assistance Administrative</li>
            <li>Maîtrise et Reduction des Coût</li>
            <li>Appui à la fonction finacière et comptable</li>
            <li>Analyse de Coût et Estimations de Proejets</li>
          </ul>
        </div>

        {/* Colonne 3 : Localisation */}
        <div className={style.footerColumn}>
          <h3>Localisation</h3>
          <ul>
            <li>Brazzaville <ImLocation /> </li>
            <li>Pointe-Noire</li>
            <li>Dolisie</li>
          </ul>
        </div>

        {/* Colonne 4 : Légal */}
        <div className={style.footerColumn}>
          <h3>Légal</h3>
          <ul>
            <li>Confidentialité</li>
            <li>Cookies</li>
            <li>Conditions d'utilisation</li>
          </ul>
        </div>

      </div>

      <div className={style.signature}>
        <p>&copy; {currentYear} Get-Conseil. Tous droits réservés.</p>
        <p>Expertise & Excellence au cœur de l'Afrique.</p>
      </div>
    </footer>
  )
}

export default Footer